import { TbCar, TbChecks, TbClock } from "react-icons/tb";

import { PatientHotelDepartureStatuses } from "@/schemas/hotelPlanningDepartureSchema";
import { CommonStatusItem } from "@/types/global";

// Brightness1RoundedIcon
import { softColors } from "./colors";

export type HotelDepartureStatusItem = CommonStatusItem & {
    cond: (cancelled: boolean, isFlightArrival: boolean, typeValid: boolean) => boolean;
    value: PatientHotelDepartureStatuses;
    label: string;
};
export const hotelDepartureStatuses: HotelDepartureStatusItem[] = [
    {
        cond: (cancelled, isFlightArrival, typeValid) => typeValid && !cancelled && !!isFlightArrival,
        component: () => TbClock,
        ...softColors.brown,
        tooltip: {
            title: "Transfer bekliyor",
            description: "Otel transferi için lobide bekliyor.",
        },
        value: PatientHotelDepartureStatuses.PENDING,
        label: "Transfer bekliyor",
    },
    {
        cond: (cancelled, isFlightArrival, typeValid) => typeValid && !cancelled && !isFlightArrival,
        component: () => TbCar,
        ...softColors.indigo,
        tooltip: {
            title: "Otel yolunda",
            description: "Otele doğru yolculukta.",
        },
        value: PatientHotelDepartureStatuses.IN_PROGRESS,
        label: "Otel yolunda",
    },
    {
        cond: (cancelled) => !!cancelled,
        component: () => TbChecks,
        ...softColors.green,
        tooltip: {
            title: "Otele bırakıldı",
            description: "Otele bırakıldı.",
        },
        value: PatientHotelDepartureStatuses.COMPLETED,
        label: "Otele bırakıldı",
    },
];
